export * from './edit-treatment-message-template.component';
